module.exports = __webpack_public_path__ + "static/media/github.c8a83d07.png";